import { createUiStateStore } from '@/react-app/shared';

export interface RecentlyVisitedRecord {
  name: string | null | undefined;
  path: string;
  visitedAt: string;
  moduleName?: string;
  title?: string;
}

interface RecentlyVisitedState {
  records: RecentlyVisitedRecord[];
}

const STORE_KEY = 'recently-visited/store';
const defaults: RecentlyVisitedState = { records: [] };

export const useRecentlyVisitedStore = createUiStateStore<RecentlyVisitedState>(STORE_KEY, defaults);

// Standalone function for Vue plugin to call
export async function addRecentlyVisited(route: {
  name: any;
  path: string;
  meta?: {
    moduleName?: string;
    title?: string | ((route: any) => string | null) | ((route: any) => Promise<string | null>) | null;
  };
}) {
  const store = useRecentlyVisitedStore.getState();
  const { state, setState } = store;

  // Resolve title - if it's a function, call it to get the translated title
  let title: string | undefined;
  if (typeof route.meta?.title === 'function') {
    try {
      const result = await route.meta.title(route);
      title = result ?? undefined;
    } catch (error) {
      console.error('Error resolving route title:', error);
      title = undefined;
    }
  } else if (typeof route.meta?.title === 'string') {
    title = route.meta.title;
  }

  const newRecord: RecentlyVisitedRecord = {
    name: typeof route.name === 'string' ? route.name : null,
    path: route.path,
    visitedAt: new Date().toISOString(),
    moduleName: route.meta?.moduleName,
    title,
  };

  // Keep max 5 unique records, sorted by visitedAt desc
  const uniqueRecords = [newRecord, ...state.records.filter((r) => r.path !== route.path)].slice(0, 5);

  setState({ records: uniqueRecords });

  // If store hasn't fetched yet, the records will be merged on first fetch
  // This matches the Vue store behavior
}
